class AddEditTestSuiteController {
    constructor(ManageTestSuiteServiceApi, ModalService, toastr, moment) {
        this.$onInit = () => {
            this.init();
        };
        this.save = () => {
            // Save changes to existing TestSuite or a newly defined one to the
            // database via the web api
            if (this.isXML(this.suite.TestSuiteXML)) {
                let suiteToSave = {
                    ExpiryDate: this.suite.ExpiryDate,
                    Id: this.suite.Id,
                    IsDeleted: this.suite.IsDeleted,
                    LastAmended: null,
                    LastAmendedBy: null,
                    TestSuiteName: this.suite.TestSuiteName,
                    TestSuiteXML: this.suite.TestSuiteXML,
                    TestSuiteUid: this.suite.TestSuiteUid,
                    IdPId: null,
                    Script: this.suite.Script
                };
                this.ManageTestSuiteServiceApi.saveTestSuite(suiteToSave).then(response => {
                    let saveResults = response.data;
                    // ensure we have a response
                    if (!angular.isUndefined(saveResults)) {
                        // If there are errors, then act
                        if (saveResults.errors.length > 0) {
                            this.validationErrors = saveResults.errors;
                            angular.forEach(this.validationErrors, validationError => {
                                this.toastr.error(validationError);
                            });
                            return;
                        }
                        let closeResult = {
                            newSuite: this.suite,
                            modalAction: this.suite.Id > 0 ? 'updated' : 'added'
                        };
                        this.close({ $value: closeResult });
                    }
                    else {
                        // should never happen but may cause issues when we hang the timeout during debugging - this will handle the case where users experience a slow response and the timeout is hit.
                        this.toastr.info('Error Saving Details please double check all mandatory fields are completed.');
                    }
                });
            }
            else {
                this.toastr.error('The Xml parameters submitted are not valid.  Please correct then re-submit!');
            }
        };
        this.isXML = (xmlString) => {
            try {
                return $.parseXML(xmlString) ? true : false;
            }
            catch (err) {
                // was not XML
                return false;
            }
        };
        this.cancel = () => {
            // Cancel the page without any changes
            this.dismiss();
        };
        this.init = () => {
            this.validationErrors = [];
            this.state = {
                expiryLimit: -1,
                expiryRules: {}
            };
            this.data = {
                action: 'Create'
            };
            // We Need to specify the options in here as the page COULD load prior to the settings service promise resolving - this causes a problem.
            this.datePicker = {
                date: '',
                options: {}
            };
            this.suite = {};
            let params = this.resolve;
            this.suite = angular.copy(params.suite);
            this.visibleExpirys = params.visibleExpirys;
            this.datePicker = {
                date: '',
                options: params.datepickerOptions
            };
            // Wire up our event handler to the modal function
            this.datePicker.options.eventHandlers = {
                'apply.daterangepicker': (ev, picker) => {
                    this.selectDate(ev);
                }
            };
            this.state.expiryLimit = params.expiryLimit;
            this.state.expiryRules = {
                showRed: this.visibleExpirys.indexOf('R') > -1,
                showAmber: this.visibleExpirys.indexOf('A') > -1,
                showGreen: this.visibleExpirys.indexOf('G') > -1,
                showUncategorized: this.visibleExpirys.indexOf('U') > -1
            };
            if (this.suite.TestSuiteName === null || this.suite.TestSuiteName === undefined) {
                this.suite = {
                    Id: -1,
                    TestSuiteName: '',
                    TestSuiteUid: '',
                    TestSuiteXML: '',
                    ExpiryDate: null,
                    IsDeleted: false,
                    expiryClass: '',
                    popupText: '',
                    TestPlanData: '',
                    UserName: '',
                    Description: '',
                    TestCaseVariableCount: 0,
                    Script: false
                };
                this.data.action = 'Create';
                this.datePicker.date = this.moment().startOf('day');
            }
            else {
                // Check if the suites current class is not to be displayed - if not then hide it.
                if ((this.suite.expiryClass === 'traffic-danger' &&
                    !this.state.expiryRules.showRed) ||
                    (this.suite.expiryClass === 'traffic-warning' &&
                        !this.state.expiryRules.showAmber) ||
                    (this.suite.expiryClass === 'traffic-success' &&
                        !this.state.expiryRules.showGreen) ||
                    (this.suite.expiryClass === 'traffic-off' &&
                        !this.state.expiryRules.showUncategorized)) {
                    this.suite.expiryClass = '';
                }
                // @ts-ignore : html_beautify ??
                this.suite.TestSuiteXML = html_beautify(this.suite.TestSuiteXML).trim();
                if (this.suite.ExpiryDate !== null &&
                    typeof this.suite.ExpiryDate !== 'undefined' &&
                    this.suite.ExpiryDate !== undefined) {
                    this.datePicker.date = this.moment(this.suite.ExpiryDate).startOf('day');
                }
                this.data.action = 'Update';
            }
        };
        this.selectDate = (ev) => {
            this.suite.ExpiryDate = ev.model._d;
            this.generateExpiryClass();
        };
        this.clearDates = () => {
            this.datePicker.date = '';
            this.suite.ExpiryDate = null;
            this.generateExpiryClass();
        };
        this.generateExpiryClass = () => {
            if (this.suite.ExpiryDate === undefined ||
                this.suite.ExpiryDate === null) {
                if (this.state.expiryRules.showUncategorized) {
                    this.suite.expiryClass = 'traffic-off';
                }
                else {
                    this.suite.expiryClass = '';
                }
                return;
            }
            const expiryMoment = this.moment(this.suite.ExpiryDate);
            const today = this.moment();
            let colour = 'traffic-success';
            // TODO : impliment expiry rules on both this modal window and the main page not just here.
            // if (this.state.expiryRules.showGreen) {
            //     colour = 'traffic-success';
            // }
            // if (today.isAfter(expiryMoment) && this.state.expiryRules.showRed) {
            if (today.isAfter(expiryMoment)) {
                colour = 'traffic-danger';
            }
            else if (
            // expiryMoment.diff(today, 'days') < this.state.expiryLimit && this.state.expiryRules.showAmber
            expiryMoment.diff(today, 'days') < this.state.expiryLimit) {
                colour = 'traffic-warning';
            }
            this.suite.expiryClass = colour;
        };
        this.ManageTestSuiteServiceApi = ManageTestSuiteServiceApi;
        this.ModalService = ModalService;
        this.toastr = toastr;
        this.moment = moment;
    }
}
angular.module('app').component('addTestSuiteComponent', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/ManageTestSuites/add-edit-test-suite.tpl.html',
    controllerAs: 'vm',
    controller: AddEditTestSuiteController
});
